import React, { useState } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Button,
  notification,
} from "antd";
import { debitNoteService } from "../../../../../services";
import MaterialLikeSelect from "../../../../../components/MaterialLikeSelect";
import MaterialLikeDatePicker from "../../../../../components/MaterialLikeDatePicker";
import MaterialLikeInput from "../../../../../components/MaterialLikeInput";
import MaterialLikeTextArea from "../../../../../components/MaterialLikeTextArea ";

const AddModal = ({
  visible,
  setIsModalShow,
  onCancel,
  companies,
  customers,
  invoices,
  expenses,
  setRefresh
}) => {

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleClose = () => {
    setRefresh(true)
    form.resetFields();
    setIsModalShow(false);
  };

  const onFinish = async (values) => {
    setLoading(true);
    const data = {
      ...values,
      issue_date: values.issue_date.format("YYYY-MM-DD"),
    };
    const response = await debitNoteService.addDebitNote(data);
    if (response.success) {
      notification.success({
        message: "Successfully Added!",
        description: response.message,
        placement: "topRight",
      });
    }
    setLoading(false);
    handleClose();
  };

  return (
    <Modal
      title={<div style={{ width: "100%" }}>Create Debit Note</div>}
      open={visible}
      onCancel={onCancel}
      footer={null}
      closable={true}
      width={700}
      style={{ padding: "15px" }}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        requiredMark={false}
      >
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="company_id"
              rules={[{ required: true, message: "Please select a company" }]}
            >
              <MaterialLikeSelect
                label="Select Company"
                required
                value={form.getFieldValue("company_id")}
                onChange={(value) => form.setFieldValue('company_id', value)}
                options={companies?.map((comp) => ({
                  id: comp.id,
                  value: comp.id,
                  label: comp.name,
                }))}
              />
              {/* <Select placeholder="Select Inter-Company">
                {companies.map((comp) => (
                  <Select.Option key={comp.id} value={comp.id}>
                    {comp.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="user_id"
              rules={[{ required: true, message: "Please select a customer" }]}
            >
              <MaterialLikeSelect
                label="Select Customer"
                required
                value={form.getFieldValue("user_id")}
                onChange={(value) => form.setFieldValue('user_id', value)}
                options={customers?.map((cust) => ({
                  id: cust.id,
                  value: cust.id,
                  label: cust.name,
                }))}
              />
              {/* <Select placeholder="Select Customer">
                {customers.map((cust) => (
                  <Select.Option key={cust.id} value={cust.id}>
                    {cust.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="invoice_id"
              rules={[{ required: true, message: "Please select an invoice" }]}
            >
              <MaterialLikeSelect
                label="Select Invoice"
                required
                value={form.getFieldValue("invoice_id")}
                onChange={(value) => form.setFieldValue('invoice_id', value)}
                options={invoices?.map((invoice) => ({
                  id: invoice.id,
                  value: invoice.id,
                  label: invoice.name,
                }))}
              />
              {/* <Select placeholder="Select Invoice">
                {invoices.map((invoice) => (
                  <Select.Option key={invoice.id} value={invoice.id}>
                    {invoice.id}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="expense_id">
              <MaterialLikeSelect
                label="Select Expense"
                value={form.getFieldValue("expense_id")}
                onChange={(value) => form.setFieldValue('expense_id', value)}
                options={expenses?.map((expense) => ({
                  id: expense.id,
                  value: expense.id,
                  label: expense.name,
                }))}
              />
              {/* <Select placeholder="91099">
                {expenses.map((expense) => (
                  <Select.Option key={expense.id} value={expense.id}>
                    {expense.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="amount"
              rules={[{ required: true, message: "Please enter the amount" }]}
            >
              <MaterialLikeInput
                label="Amount"
                value={form.getFieldValue("amount")}
                onChange={(e) => form.setFieldValue("amount", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="issue_date"
              rules={[{ required: true, message: "Please select a date" }]}
            >
              <MaterialLikeDatePicker
                label="Issue Date"
                required
                value={form.getFieldValue("issue_date")}
                onChange={(date) => form.setFieldValue("issue_date", date)}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="description">
              <MaterialLikeTextArea
                label="Description"
                rows={4}
                value={form.getFieldValue("description")}
                onChange={(e) => form.setFieldValue("description", e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Col span={24}>
          <Form.Item style={{ marginTop: 10, textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{ width: "70%" }}
            >
              Create Debit Note
            </Button>
          </Form.Item>
        </Col>
      </Form>
    </Modal>
  );
};

export default AddModal;
